import * as actionTypes from './actionTypes';
import apiCall from '../app/apiCall';

export const fetchActivitiesRequest = () => ({
  type: actionTypes.FETCH_ACTIVITIES_REQUEST
});
export const fetchActivitiesFailure = message => ({
  type: actionTypes.FETCH_ACTIVITIES_FAILURE,
  message
});
export const fetchActivitiesSuccess = activities => ({
  type: actionTypes.FETCH_ACTIVITIES_SUCCESS,
  activities
});
export const updateCalendarActivities = activities => ({
  type: actionTypes.UPDATE_CALENDAR_ACTIVITIES,
  activities
});

export function activitySave(activityId, data) {
  return () => {
    const activitySaveUrl = `activities/${activityId}`;
    return apiCall(activitySaveUrl, 'put', data);
  };
}

export const fetchActivities = (
  staffId,
  startDate,
  endDate,
  bidSessionId,
  categoryId
) => {
  return async dispatch => {
    dispatch(fetchActivitiesRequest());

    let activities, typesArr;
    const types = new Map();
    try {
      let data = await Promise.all([
        fetch(`api/activities/preassignments`)
          .then(res => res.json())
          .then(json => {
            activities = json;
          }),

        fetch(`api/activities/types`)
          .then(res => res.json())
          .then(json => {
            typesArr = json.entries;

            typesArr.map(type => {
              types.set(type.activityTypeId, type.backgroundColorHex);
              return type;
            });
          })
      ]);
      if (activities !== null && typesArr !== null) {
        return dispatch(fetchActivitiesSuccess({ activities, types }));
      }
    } catch (error) {
      console.log('mockFetchActivities error', error);
      dispatch(fetchActivitiesFailure(error));
    }
  };
};

export function updateCalendar(activities) {
  return dispatch => {
    dispatch(updateCalendarActivities({ activities }));
  };
}

export function checkLegalityService(
  bidSessionId,
  categoryId,
  staffId,
  activitiesIds
) {
  return () => {
    const activityDetailsRequestUrl = `activities/bid-session/${bidSessionId}/category/${categoryId}/employee/${staffId}/legality`;
    return apiCall(activityDetailsRequestUrl, 'post', activitiesIds);
  };
}

export const getStatistics = (bidSessionId, categoryId, staffId) => {
  return dispatch =>
    fetch(
      `api/preferences/statistics/bid-session/${bidSessionId}/category/${categoryId}/employee/${staffId}`
    )
      .then(res => res.json())
      .then(json => {
        return json;
      });
};

export function removeActivity(activityId) {
  return dispatch => {
    dispatch({
      type: actionTypes.REMOVE_ACTIVITY,
      activityId
    });
  };
}

export function updateActivity(activity) {
  return dispatch => {
    dispatch({
      type: actionTypes.UPDATE_ACTIVITY,
      activity
    });
  };
}
